import enUsTranslations from './en-us.js';

const resources = {
    'pt-BR': {},
    'en-US': enUsTranslations,
};

export default resources;